import { IconButton, Tooltip } from "@mui/material";
import React from "react";
import * as IconsSVG from "../../../../../../assets/iconsSVG";
import * as Styles from "./styles";

interface Props {
  onClick: () => void;
  badgeCount: number;
  disabled?: boolean;
}

const ButtonClearFilter: React.FC<Props> = ({
  onClick,
  badgeCount,
  disabled,
}) => {
  return (
    <Tooltip followCursor title="Limpar filtro" placement="top" arrow>
      <Styles.Container>
        <IconButton
          disabled={disabled}
          onClick={onClick}
          style={{
            backgroundColor: "#fff",
            borderRadius: 4,
            marginRight: 8,
            borderWidth: 1,
            borderColor: "#f0f0f0",
            borderStyle: "solid",
            opacity: disabled ? 0.5 : 1,
          }}
        >
          <IconsSVG.ClearFilterGrid />
        </IconButton>
        {badgeCount > 0 && ( // Renderiza a badge somente se houver uma contagem maior que zero
          <Styles.Badge>
            <Styles.BadgeText>{badgeCount}</Styles.BadgeText>
          </Styles.Badge>
        )}
      </Styles.Container>
    </Tooltip>
  );
};

export default ButtonClearFilter;
